<template>
  <div id="Auth" class="clearfix">
    <div class="userName">
      <span>
        用户名：{{user.name }}
      </span>
    </div>
    <div class="container">
      <div class="header">
        <p>手机号绑定</p>
        <p />
      </div>
      <div class="form">
        <el-form
          :model="ruleForm"
          status-icon
          ref="ruleForm"
          label-width="0px"
          class="demo-ruleForm ruleForm"
        >
          <div class="steps-form">
            <el-form-item prop="mobile">
              <el-row type="flex" class="row-bg header_fidx" :span="24">
                <el-col :span="4" class="col_row1 col_txt2">
                  <a class="grid-content">手机号</a>
                </el-col>
                <el-col :span="18" class="col_row1 col_txt1">
                  <a class="grid-content">
                    <input
                      v-model.trim="ruleForm.mobile"
                      type="text"
                      placeholder="请输入手机号"
                      class="form-input"
                      name="mobile"
                      clearable
                    />
                  </a>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item prop="verify">
              <el-row type="flex" class="row-bg header_fidx" :span="24">
                <el-col :span="4" class="col_row2 col_txt2">
                  <a class="grid-content">验证码</a>
                </el-col>
                <el-col :span="10" class="col_row2 col_txt1">
                  <a class="grid-content">
                    <input
                      v-model.trim="ruleForm.verify"
                      type="text"
                      placeholder="请输入验证码"
                      class="form-input"
                      name="verify"
                      clearable
                    />
                  </a>
                </el-col>
                <el-col :span="8" class="grid-button">
                  <a class="grid-content">
                    <div
                      @click="getCode()"
                      v-show="isgetCode"
                      class="getCode-button"
                    >
                      点击获取
                    </div>
                    <div
                      v-show="!isgetCode"
                      @click="getCode()"
                      v-bind:class="{ active: isActive }"
                      class="verifyPhone-button"
                    >
                      <span v-show="isActive">重新获取</span>
                      <span v-show="!isActive">{{ count }}s</span>
                    </div>
                  </a>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <div class="form-bottom">
            <el-form-item>
              <el-button
                type="primary"
                class="form-bottom-button"
                @click="submitForm()"
                >确认</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { authApi } from '@/api'
import { mapGetters } from 'vuex'
const TIME_COUNT = 60
export default {
  components: {},

  data() {
    return {
      isgetCode: true,
      isActive: false,
      isSending: false,
      count: 0,
      timer: null,
      ruleForm: {
        mobile: '',
        verify: '',
      },
    }
  },

  created() {},
  mounted() {},
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    async getCode() {
      if (!this.checkPhoneNumber()) {
        this.$message.error('手机号格式错误')
        return
      }
      if (this.isSending) {
        return
      }
      this.isSending = true
      let mobile = this.ruleForm.mobile
      let data = (await authApi.sendSms({'mobile': mobile})).data
      if (data.code === 0) {
        this.isgetCode = false
        if (!this.timer) {
          this.isActive = false
          this.count = TIME_COUNT
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
            } else {
              clearInterval(this.timer)
              this.timer = null
              this.isActive = true
              this.isSending = false
            }
          }, 1000)
        }
      } else {
        this.$error(data)
        this.isSending = false
      }
    },
    checkPhoneNumber() {
      var phone_reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!this.ruleForm.mobile || !phone_reg.test(this.ruleForm.mobile)) {
        return false
      } else {
        return true
      }
    },
    async submitForm() {
      let uuid = JSON.parse(window.localStorage.getItem('user')).user.uuid
      let data = (await authApi.submitMobile({'mobile': this.ruleForm.mobile, 'uuid': uuid, 'code': this.ruleForm.verify})).data
      if (data.code === 0) {
        this.$message.success('手机号绑定成功')
        this.backToList()
      } else {
        this.$message.error(`${data.msg}`)
      }
    },
    backToList() {
      var t
      var that = this
      clearTimeout(t)
      t = setTimeout(function () {
        that.$router.go(-1)
      }, 1500)
    },
  },
}
</script>
<style lang='less' scoped>
#Auth {
  background: #324057;
  position: relative;
  width: 100%;
  height: 100vh;
  .userName{
    font-size: 21px;
    color:#fff;
    position: absolute;
    right:3%;
    top:3%;
  }
  .container {
    width:500px;
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
  }
  .header {
    width: 100%;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    text-align: center;
    margin-bottom: 50px;
  }
  .form {
    width: 100%;
  }
  .steps-form {
    width: 100%;
    overflow: hidden;
    line-height: 3.75rem;
    .grid-content {
      max-height: 3.75rem;
      line-height: 3.75rem;
    }
    .col_txt1 {
      text-align: left;
    }
    .col_txt2 {
      text-align: center;
      .grid-content{
        color:#fff;

      }
    }

    .header_fidx {
      position: relative;
    }

    input:focus {
      outline: none;
    }
    input {
      outline: medium;
      border: none;
    }

    .form-input {
      width: 100%;
      max-height: 3.125rem;
      line-height: 3.125rem;
      padding-left: 5px;
      position: relative;
    }
    .grid-button{
      position: relative;
    }

    .getCode-button {
      position: absolute;
      top:12px;
      right:30%;
      color: #fff;
      background-color: #409eff;
      border: 0.0625rem solid #409eff;
      border-radius: 0.3125rem;
      width: 5.5625rem;
      height: 2.375rem;
      line-height: 2.375rem;
      text-align: center;
      font-size: 1rem;
    }

    .verifyPhone-button {
      position: absolute;
      top:12px;
      right:30%;
      border: 0.0625rem solid #ccc;
      background: #f7f7f7;
      color: #999;
      border-radius: 0.3125rem;
      width: 5.5625rem;
      height: 2.375rem;
      line-height: 2.375rem;
      text-align: center;
      font-size: 1rem;
    }

    .active {
      border: 0.0625rem solid #3980ea;
      background: #fff;
      color: #3980ea;
    }

    .mobileData {
      color: #999;
    }
  }

  .form-bottom {
    width: 100%;
    text-align: center;
    height: 3.5rem;
    .form-bottom-button {
      width: 30%;

    }
  }
}
</style>
